// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_J0B","cls2":"CreateSocialItemModal-cls2_F66 CreateSocialItemModal-cls1_J0B"};